import { getLocalTodayString } from '../../../../components/CreationDate';
export const isDeliveryDate = value => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
};
export const localDeliveryTime = (date = getLocalTodayString()) => {
  const now = new Date();
  return `${date}T${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
};
export const deliveryTimeWithOffset = value => {
  const date = new Date(value);
  if (!value || !isDeliveryDate(value.slice(0, 10)) || Number.isNaN(date.getTime())) throw new Error('Select a valid delivery date and time.');
  const offset = -date.getTimezoneOffset();
  const minutes = Math.abs(offset);
  return `${value}${offset >= 0 ? '+' : '-'}${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
};

export const validateDeliveryProductDates = products => {
  products.forEach((product, index) => {
    const prefix = 'Product ' + (index + 1) + ': ';
    if (!product.useByDate) throw new Error(prefix + 'Use-by Date is required.');
    if (!isDeliveryDate(product.useByDate)) throw new Error(prefix + 'Select a valid Use-by Date.');
    if (product.bestBefore && !isDeliveryDate(product.bestBefore)) throw new Error(prefix + 'Select a valid Best Before date.');
  });
};
